import { useCallback } from 'react'
import { VersionReportVersionPageFormModel } from '../../../model/VersionReportVersionPageFormModel'

export const usePageConfigHandlers = (
  page: VersionReportVersionPageFormModel,
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportVersionPageFormModel
    ) => VersionReportVersionPageFormModel
  ) => void
) => {
  const handlePageTitleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onUpdate(page.pageNumber, prev => ({
        ...prev,
        pageTitle: e.target.value,
      }))
    },
    [page.pageNumber, onUpdate]
  )

  return {
    handlePageTitleChange,
  }
}
